import { useEffect } from 'react'
import { useAppStore } from './store/useAppStore'
import Esper from './components/Esper'


function App() {
  const { theme, setTheme } = useAppStore()

  // Apply theme on mount and theme change
  useEffect(() => {
    const root = window.document.documentElement
    const body = window.document.body
    
    root.classList.remove('light', 'dark')
    root.classList.add(theme)
    
    body.classList.remove('light', 'dark')
    body.classList.add(theme)
  }, [theme])

  return (
    <div className="editor-app">
      <Esper />
    </div>
  )
}


export default App
